import { formatElapsed } from "./useStepClock"

export type StepTone = "ask" | "new" | "ok" | "run" | "idle"

/** One row of the Run list: the step, its live time, and its section with where that stands. */
export interface RunStep {
  id: string
  name: string
  section?: string
  elapsed: number | null
  /** "1 question", "3 new", "Confirmed", "Running", "Not started". */
  status: string
  tone: StepTone
  /** Set when the step has a tab to open. */
  tab?: boolean
}

/** The one Run list: replaces the separate outline and ladder. Total at the bottom. */
export function RunList({ steps, selected, onOpen }: { steps: RunStep[]; selected: string; onOpen: (id: string) => void }) {
  const total = steps.reduce((n, s) => n + (s.elapsed ?? 0), 0)
  const any = steps.some((s) => s.elapsed != null)
  return (
    <div className="nsd-runl">
      <p className="ncf-eyebrow">Run</p>
      <ol aria-label="Run">
        {steps.map((s) => (
          <li key={s.id} className={`nsd-rs ${s.tone}${selected === s.id ? " cur" : ""}`}>
            {s.tab ? (
              <button type="button" className="nsd-rs-b" aria-current={selected === s.id ? "true" : undefined} onClick={() => onOpen(s.id)}>
                <RunRow s={s} />
              </button>
            ) : (
              <div className="nsd-rs-b"><RunRow s={s} /></div>
            )}
          </li>
        ))}
      </ol>
      <p className="nsd-rs-total"><span>Total</span><span className="mono" data-testid="run-total">{any ? formatElapsed(total) : "–"}</span></p>
    </div>
  )
}

function RunRow({ s }: { s: RunStep }) {
  return (
    <>
      <span className="nsd-rs-top"><b>{s.name}</b><span className="mono nsd-rs-time" data-testid={`time-${s.id}`}>{formatElapsed(s.elapsed)}</span></span>
      <span className="nsd-rs-sub">{s.section ? `${s.section} · ` : ""}{s.status}</span>
    </>
  )
}
